import { TypesForFormCreated } from '../../interface/Destructuring';

export const FormCreated = (
  { activity, errors, handlerChange, handlerSubmit, listCountries, SelectCountries, DeleteCountries, }:
    TypesForFormCreated
) => {
  return (
    <div className='form' >
      <form onSubmit={(e) => handlerSubmit(e)} className="formItems">
        <div className="eachElement">
          <label className="label">*Nombre: </label>
          <input
            type="text"
            name="name"
            placeholder="Ej: Natación"
            onChange={(e) => handlerChange(e)}
            className="inputAndSelect"
          />
          {errors.name && (
            <span className='errors' >
              <strong>{errors.name}</strong>
            </span>
          )}
        </div>

        <div className="eachElement">
          <label className="label">*Dificultad: </label>
          <select
            name="difficulty"
            onChange={(e) => handlerChange(e)}
            className="inputAndSelect"
          >
            <option className='option'>Dificultad</option>
            <option className='option' value="1">1 - Muy Fácil</option>
            <option className='option' value="2">2 - Fácil</option>
            <option className='option' value="3">3 - Medio</option>
            <option className='option' value="4">4 - Difícil</option>
            <option className='option' value="5">5 - Muy Difícil</option>
          </select>
          {errors.name && !activity.difficulty && (
            <span className='errors' >
              <strong>{errors.difficulty}</strong>
            </span>
          )}
        </div>

        <div className="eachElement">
          <label className="label">*Duración: </label>
          <select
            name="duration"
            onChange={(e) => handlerChange(e)}
            className="inputAndSelect"
          >
            <option className='option'>Duración</option>
            <option className='option' value={1}>1 Hora</option>
            <option className='option' value={2}>2 Horas</option>
            <option className='option' value={3}>3 Horas</option>
            <option className='option' value={4}>4 Horas</option>
            <option className='option' value={5}>5 Horas</option>
          </select>
          {errors.name && errors.difficulty && (
            <span className='errors' >
              <strong>{errors.duration}</strong>
            </span>
          )}
        </div>

        <div className="eachElement">
          <label className="label">*Temporada: </label>
          <select
            name="season"
            onChange={(e) => handlerChange(e)}
            className="inputAndSelect"
          >
            <option className='option'>Temporada</option>
            <option className='option' value="Verano">Verano</option>
            <option className='option' value="Otoño">Otoño</option>
            <option className='option' value="Invierno">Invierno</option>
            <option className='option' value="Primavera">Primavera</option>
          </select>
          {errors.name && errors.difficulty && errors.duration && (
            <span className='errors' >
              <strong>{errors.season}</strong>
            </span>
          )}
        </div>

        <div className="eachElement">
          <div className="allCountries">
            <label className="label">*País(es): </label>
            <select
              name="nameCountry"
              onChange={(e) => SelectCountries(e)}
              className="inputAndSelect"
            >
              <option className='option'>
                Seleccionar País(es)
              </option>
              {listCountries}
            </select>
          </div>
          <div className="countries">
            {activity.country.map((el: string, index: number) => {
              return (
                <div key={index} className="containCountry">
                  <p>{el}</p>
                  <div onClick={() => DeleteCountries(el)} className="delete" >X</div>
                </div>
              );
            })}
          </div>
          {!activity.country.length && <p>{errors.country}</p>}
        </div>

        <div className="containSubmit">
          {activity.name &&
            activity.difficulty &&
            activity.duration &&
            activity.season &&
            activity.country.length &&
            !(
              errors.name &&
              errors.difficulty &&
              errors.duration &&
              errors.season &&
              errors.country
            ) ? (
            <button type="submit">
              Crear Actividad
            </button>
          ) : (
            <p>Llena los campos requeridos (*)</p>
          )}
        </div>
      </form>
    </div>
  )
}
